module.exports = __webpack_public_path__ + "assets/question.43ff77d7.svg";